import { Typography, useTheme } from '@material-ui/core'
import { WorkingStepIconSvg } from 'components/Common/WorkingSteps/WorkingStepIcon'
import { isEqual } from 'lodash'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { WorkingStepDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { projectSelectors } from 'features/BillOfMaterials/store/selectors/projectSelectors'
import { WorkingStepResourceSelector } from '../WorkingSteps/WorkingStepResourceSelector'
import { useRoutingHeaderStyles } from './RoutingHeader.styles'
import { useNotAllowedWorkingStep } from '../WorkingSteps/useNotAllowedWorkingStep'

export const BomItemRoutingData = (props: {
  bomItemId: string
  rootClassName?: string
  listItemClassName?: string
}) => {
  const bomItemWorkingSteps = useAppSelector(
    projectSelectors.bomItemWorkingStepsSelector({
      bomItemId: props.bomItemId,
    }),
    isEqual
  )

  if (!bomItemWorkingSteps) {
    return null
  }

  return (
    <ul className={props.rootClassName}>
      {bomItemWorkingSteps.map((ws) => {
        return (
          <li key={ws.key} className={props.listItemClassName}>
            <RoutingData rowIds={[props.bomItemId]} workingStep={ws} />
          </li>
        )
      })}
    </ul>
  )
}

export const RoutingData = ({
  workingStep: ws,
  rowIds,
}: {
  workingStep: WorkingStepDto
  rowIds: string[]
  disableMatchDescription?: boolean
}) => {
  const cn = useRoutingHeaderStyles()
  const { t } = useTranslation()
  const theme = useTheme()

  const { workingStepNotAllowed } = useNotAllowedWorkingStep(
    rowIds[0],
    ws.primaryWorkingStep
  )

  if (!ws) {
    return null
  }

  return (
    <>
      <div className={cn.routingRow}>
        <div className={cn.workingStepWithResource}>
          <WorkingStepIconSvg
            workingStepType={ws.primaryWorkingStep}
            className={'working-step-icon'}
          />
          <div
            style={{
              width: '100%',
              padding: '2px',
              color: workingStepNotAllowed
                ? theme.palette.error.contrastText
                : undefined,
              backgroundColor: workingStepNotAllowed
                ? theme.palette.error.main
                : undefined,
            }}
          >
            {ws.resource?.name ? (
              <WorkingStepResourceSelector
                workingStep={ws}
                bomItemIds={rowIds}
                disableLabel
                disableUnderline
                disableMatchDescription
              />
            ) : (
              <Typography variant="caption" color="inherit">
                {t('project:no-resources-available')}
              </Typography>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
